/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/069-address-book': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3 0v16h12V0H3zm6 4.005a1.995 1.995 0 110 3.99 1.995 1.995 0 010-3.99zM12 12H6v-1a2 2 0 012-2h2a2 2 0 012 2v1zM1 1h1.5v3H1V1zM1 5h1.5v3H1V5zM1 9h1.5v3H1V9zM1 13h1.5v3H1v-3z"/>'
  }
})
